import { QUERY_KEYS_ACCOUNT } from '@/account/api/query';
import type { FavoritesResponse } from '@/account/api/types';
import { useAuthorizedApiCall } from '@/api/use-authorized-api-call';
import { getPaginationLimit } from '@/utils/get-pagination-limit';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';

interface AddProductToWishlistDto {
  productId: string;
}

export const useAddProductToWishlistMutation = () => {
  const queryClient = useQueryClient();
  const searchParams = useSearchParams();
  const current = new URLSearchParams(Array.from(searchParams.entries()));
  const limit = current.get('limit') ? Number(current.get('limit')) : undefined;
  const defaultLimit = getPaginationLimit(limit);
  const addProductToWishlist = useAuthorizedApiCall<
    FavoritesResponse,
    [AddProductToWishlistDto]
  >((api, productId) => api.post(`customers/favourites`, productId));

  return useMutation({
    mutationFn: addProductToWishlist,
    onSuccess: (data) => {
      queryClient.setQueryData(
        [QUERY_KEYS_ACCOUNT.WISHLIST, defaultLimit],
        data,
      );
    },
  });
};
